import { render, staticRenderFns } from "./PDFturnTXT.vue?vue&type=template&id=599e84fc&scoped=true&"
import script from "./PDFturnTXT.vue?vue&type=script&lang=js&"
export * from "./PDFturnTXT.vue?vue&type=script&lang=js&"
import style0 from "./PDFturnTXT.vue?vue&type=style&index=0&id=599e84fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e84fc",
  null
  
)

export default component.exports